import {Component, Input, OnInit} from '@angular/core';
import {CurrencyResolverService} from "../../../../currency-resolver.service";
import {ApCurrency} from "../../../../pipe/enum/ap-currency";

@Component({
  selector: 'fb-choose-more-fabric-finish-outer',
  templateUrl: './choose-more-fabric-finish-outer.component.html',
  styleUrls: ['./choose-more-fabric-finish-outer.component.scss']
})
export class ChooseMoreFabricFinishOuterComponent implements OnInit {
	@Input() name: string = {} as string;
	@Input() price: string = {} as string;
	@Input() currency: string = {} as string;
	@Input() image: string = {} as string;
	@Input() unit: string = {} as string;
	@Input() overview: string = {} as string;
	public selectedCurrency: ApCurrency = ApCurrency.INR;

	constructor( public _currencyResolver: CurrencyResolverService) {

	}

	ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
	}
}
